import { z } from 'zod'

export const ADMINFORMSASSIGNMENTSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsAssignmentsPostResponseSchema = z.unknown()
export type AdminFormsAssignmentsPostResponse = z.infer<typeof adminFormsAssignmentsPostResponseSchema>
